import React from "react";
import { Card } from "react-bootstrap";
import { withRouter, Link } from "react-router-dom";

import { getLabel, countryOptions } from "../schema";
import StorageImage from "../components/StorageImage";

const UserPreview = ({ doc, history }) => {
  return (
    <Card className="mb-3">
      <Card.Body>
        <div className="d-flex">
          <div className="pr-3">
            <div className="position-relative">
              <StorageImage
                path={`profile/${doc.id}.png`}
                alt="profile"
                className="avatar-md"
              />
              {doc.verified && (
                <div className="verified-badge">
                  ✓
                </div>
              )}
            </div>
          </div>
          <div className="flex-grow-1">
            <Link to={`/user/${doc.id}`}>
              <div className="header-text">
                {`${doc.firstName} ${doc.lastName}`} •{" "}
                <span>{doc.kvisYear}</span>
              </div>
            </Link>
            {doc.email && (
              <a href={`mailto:${doc.email}`} className="email-text">
                {doc.email}
              </a>
            )}
            {doc.kvisEmail && (
              <>
                <br />
                <a href={`mailto:${doc.kvisEmail}`} className="email-text">
                  {doc.kvisEmail}
                </a>
              </>
            )}
            <ul className="m-0">
              {doc.career &&
                doc.career.map((c, i) => {
                  return (
                    <li key={i}>{`${c.jobTitle}, ${c.employer}, ${getLabel(countryOptions, c.country)
                      }`}</li>
                  );
                })}
              {doc.education &&
                doc.education.map((e, i) => {
                  return (
                    <li key={i}>
                      {`${e.major}, ${e.uniName}, ${getLabel(countryOptions, e.country)
                        }${e.scholarship ? `, (${e.scholarship} Scholarship)` : ''} `}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default withRouter(UserPreview);
